var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInTransitGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "101px",
    height: "112px",
    viewBox: "0 0 101 112",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "InTransit Copy") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Empty",
    transform: "translate(-750.000000, -340.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(364.000000, 340.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "InTransit-Copy",
    transform: "translate(386.030000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.010088, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icn/pfj-copy",
    fill: "#CCCCCC"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,49.4117647 C0,88.9411765 49.0706176,112 49.0706176,112 C49.0706176,112 98.1412353,88.9411765 98.1412353,49.4117647 C98.1412353,22.1232941 76.1706841,0 49.0706176,0 C21.9705512,0 0,22.1232941 0,49.4117647 Z",
    id: "Fill-1"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#F9F9F9",
    cx: 49.0706176,
    cy: 49,
    rx: 38.5554853,
    ry: 38.5
  })), /*#__PURE__*/React.createElement("path", {
    d: "M68.1890401,41.34375 L61.0196317,41.34375 L61.0196317,31.5 L27.5623924,31.5 C24.9336093,31.5 22.7827868,33.7148438 22.7827868,36.421875 L22.7827868,63.4921875 L27.5623924,63.4921875 C27.5623924,67.5773438 30.7647281,70.875 34.7318008,70.875 C38.6988735,70.875 41.9012092,67.5773438 41.9012092,63.4921875 L56.2400261,63.4921875 C56.2400261,67.5773438 59.4423618,70.875 63.4094345,70.875 C67.3765071,70.875 70.5788429,67.5773438 70.5788429,63.4921875 L75.3584485,63.4921875 L75.3584485,51.1875 L68.1890401,41.34375 L68.1890401,41.34375 Z M34.7318012,67.1835938 C32.7482646,67.1835938 31.1470966,65.5347656 31.1470966,63.4921875 C31.1470966,61.4496094 32.7482646,59.8007813 34.7318012,59.8007813 C36.7153377,59.8007813 38.3165057,61.4496094 38.3165057,63.4921875 C38.3165057,65.5347656 36.7153377,67.1835938 34.7318012,67.1835938 L34.7318012,67.1835938 Z M66.994138,45.0351563 L71.678151,51.1875 L61.0196317,51.1875 L61.0196317,45.0351563 L66.994138,45.0351563 L66.994138,45.0351563 Z M63.4094348,67.1835938 C61.4258983,67.1835938 59.8247303,65.5347656 59.8247303,63.4921875 C59.8247303,61.4496094 61.4258983,59.8007813 63.4094348,59.8007813 C65.3929714,59.8007813 66.9941394,61.4496094 66.9941394,63.4921875 C66.9941394,65.5347656 65.3929714,67.1835938 63.4094348,67.1835938 L63.4094348,67.1835938 Z",
    id: "icon",
    fill: "#CCCCCC"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInTransitGray);
export default __webpack_public_path__ + "static/media/InTransitGray.46e856a372581967c9ad4791d27f2da6.svg";
export { ForwardRef as ReactComponent };